import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../layout/Header/Header';
import Footer from '../../../layout/Footer/Footer';
import ScrollToTop from '../../../Shared/ScrollToTop';


import pic1 from '../../../../images/about/absorbants.webp';
import bg2 from '../../../../images/background/bg2.jpg';
import charcuterie from '../../../../images/banner/charcuterie.jpg'
import Brochure from '../../../../assets/brochure devpack.pdf'
import { useTranslation } from "react-i18next";


const CharcuterieDetails = ({ lang, SetLang }) => {
    const [t, i18n] = useTranslation('traduction');

    useEffect(() => {
        // Aos.init({
        //     duration: 1500,
        //     disable: 'mobile',
        //     once: true,
        //     mirror: false
        // });
        i18n.changeLanguage(lang);
    }, [i18n, lang]);

    return (
        <>
            <Header lang={lang} SetLang={SetLang} />
            <div class="page-content bg-white">
                <div class="dlab-bnr-inr overlay-black-middle bg-pt" style={{ backgroundImage: "url(" + charcuterie + ")" }}>
                    <div class="container">
                        <div class="dlab-bnr-inr-entry">
                            <h1 class="text-white">{t('Saucisse et Charcuterie')}</h1>
                            <div class="breadcrumb-row">
                                <ul class="list-inline">
                                    <li><Link to="/">{t('Accueil')}</Link></li>
                                    <li>{t('Produits')}</li>
                                    <li>{t('Saucisse et Charcuterie')}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="content-block">
                    <div class="section-full content-inner bg-white">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-6 m-b30">
                                    <h2 class="text-black font-weight-600 m-b15">{t('Description Produits')}</h2>
                                    <p>{t('Pour un meilleur conditionnement de vos aliments frais, DEV PACK vous offre sa gamme de produits d’emballage self-service auto-absorbant, composé à 100% de mono-matériau (mousse de polystyrène).')}
                                        {t('Pour garantir cette conservation de courte durée, nos barquettes sont généralement emballées par un film étirable.')}
                                        {t('Les barquettes DEV PACK se caractérisent par leur faible poids et leur grande stabilité. Nous offrons une variété de modèles standard courants dans différentes tailles, profondeurs et différentes couleurs.')}
                                    </p>

                                </div>
                                <div class="col-lg-6">
                                    <div class="row">
                                        <div class="col-lg-12 m-b30">
                                            <img alt="" src={pic1} />
                                        </div>
                                    </div>
                                </div>
                                <div class="container">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="section-full content-inner bg-gray bg-img-fix overlay-black-dark" style={{ backgroundImage: "url(" + bg2 + ")" }}>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 post card-container">

                            <div class="section-content box-sort-in  button-example m-b30">
                                <button type="button" class="btn btn-secondary btn-lg btn-block">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
                                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />    </svg>
                                    <a href={Brochure}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="Brochure"
                                    >
                                        {t('Télécharger Brochure')}
                                    </a>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer lang={lang} SetLang={SetLang} />
            <ScrollToTop className="scroltop style2 radius " />

        </>
    )
}
export default CharcuterieDetails;